(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[331],{

/***/ 3284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(4761);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/is-element/is-element.js
var is_element = __webpack_require__(4241);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(6817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Breadcrumbs/Breadcrumbs.styles.js


var useStyles = (0,create_styles/* createStyles */.k)((theme) => ({
  root: {
    display: "flex",
    alignItems: "center"
  },
  breadcrumb: {
    lineHeight: 1,
    whiteSpace: "nowrap",
    WebkitTapHighlightColor: "transparent"
  },
  separator: {
    marginLeft: theme.spacing.xs,
    marginRight: theme.spacing.xs,
    color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[7],
    lineHeight: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
}));

/* harmony default export */ var Breadcrumbs_styles = (useStyles);
//# sourceMappingURL=Breadcrumbs.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(5117);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Breadcrumbs/Breadcrumbs.js







var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  separator: "/"
};
const Breadcrumbs = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Breadcrumbs", defaultProps, props), { className, children, separator, classNames, styles, unstyled } = _a, others = __objRest(_a, ["className", "children", "separator", "classNames", "styles", "unstyled"]);
  const { classes, cx } = Breadcrumbs_styles(null, { classNames, styles, unstyled, name: "Breadcrumbs" });
  const items = react.Children.toArray(children).reduce((acc, child, index, array) => {
    var _a2;
    const item = (0,is_element/* isElement */.k)(child) ? react.cloneElement(child, {
      className: cx(classes.breadcrumb, (_a2 = child.props) == null ? void 0 : _a2.className),
      key: index
    }) : /* @__PURE__ */ react.createElement("div", {
      className: classes.breadcrumb,
      key: index
    }, child);
    acc.push(item);
    if (index !== array.length - 1) {
      acc.push(/* @__PURE__ */ react.createElement(Text/* Text */.x, {
        size: "sm",
        className: classes.separator,
        key: `separator-${index}`
      }, separator));
    }
    return acc;
  }, []);
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadValues({
    className: cx(classes.root, className),
    ref
  }, others), items);
});
Breadcrumbs.displayName = "@mantine/core/Breadcrumbs";


//# sourceMappingURL=Breadcrumbs.js.map


/***/ }),

/***/ 8623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ Skeleton; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 4 modules
var MantineProvider = __webpack_require__(4761);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(917);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(6817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Skeleton/Skeleton.styles.js


const fade = (0,emotion_react_browser_esm/* keyframes */.F4)({
  "from, to": { opacity: 0.4 },
  "50%": { opacity: 1 }
});
var useStyles = (0,create_styles/* createStyles */.k)((theme, { height, width, radius, circle, animate }) => ({
  root: {
    height,
    width: circle ? height : width,
    borderRadius: circle ? height : theme.fn.radius(radius),
    position: "relative",
    WebkitTransform: "translateZ(0)"
  },
  visible: {
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      background: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.white,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 10
    },
    "&::after": {
      content: '""',
      position: "absolute",
      background: theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3],
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      animation: animate ? `${fade} 1500ms linear infinite` : "none",
      zIndex: 11
    }
  }
}));

/* harmony default export */ var Skeleton_styles = (useStyles);

//# sourceMappingURL=Skeleton.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Skeleton/Skeleton.js





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const defaultProps = {
  height: "auto",
  width: "100%",
  visible: true,
  animate: true
};
const Skeleton = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Skeleton", defaultProps, props), { height, width, visible, animate, className, circle, radius, unstyled } = _a, others = __objRest(_a, ["height", "width", "visible", "animate", "className", "circle", "radius", "unstyled"]);
  const { classes, cx } = Skeleton_styles({ height, width, circle, radius, animate }, { unstyled, name: "Skeleton" });
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, __spreadValues({
    className: cx(classes.root, { [classes.visible]: visible }, className),
    ref
  }, others));
});
Skeleton.displayName = "@mantine/core/Skeleton";


//# sourceMappingURL=Skeleton.js.map


/***/ }),

/***/ 3992:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chinh-sach-dau-tu-hop-tac",
      function () {
        return __webpack_require__(2231);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Skeleton/Skeleton.js + 1 modules
var Skeleton = __webpack_require__(8623);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Breadcrumbs/Breadcrumbs.js + 1 modules
var Breadcrumbs = __webpack_require__(3284);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(5117);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./public/icons/vector_breadcrumbs.png
/* harmony default export */ var vector_breadcrumbs = ({"src":"/_next/static/media/vector_breadcrumbs.238a2498.png","height":75,"width":75,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAFVBMVEVMaXEAAAAAAAAAAAAAAAAAAAAAAACpf3wfAAAAB3RSTlMAoQtQrjwkp+/75AAAAAlwSFlzAAAhOAAAITgBRZYxYAAAABpJREFUCJljYGBjZGKAAFYWPCxmRuw0G4QGAApUAD5UPdIXAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./common/components/Breadcrumbs.js






var AppBreadcrumbs = function(param) {
    var items = param.items, isLoading = param.isLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* Skeleton */.O, {
        visible: isLoading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* Breadcrumbs */.O, {
            separator: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: vector_breadcrumbs,
                alt: "vector",
                width: 10,
                height: 12
            }),
            children: items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: item.href || "#",
                    scroll: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            color: "#000",
                            size: "xs",
                            lineClamp: index === items.length - 1 ? 1 : 2,
                            sx: {
                                width: index === items.length - 1 ? "fit-content" : "max-content"
                            },
                            weight: index === items.length - 1 ? 600 : 400,
                            children: item.title
                        })
                    })
                }, index);
            })
        })
    });
};
AppBreadcrumbs.propTypes = {
    items: (prop_types_default()).array.isRequired
};
/* harmony default export */ var components_Breadcrumbs = (AppBreadcrumbs);


/***/ }),

/***/ 3503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DanhMuc; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./apis/queryFunctions/tracking.js
var tracking = __webpack_require__(7860);
// EXTERNAL MODULE: ./pages/tin-tuc/components/NewsTag.js
var NewsTag = __webpack_require__(5704);
// EXTERNAL MODULE: ./utils/uppercaseFirstLetter.js
var uppercaseFirstLetter = __webpack_require__(4571);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Group/Group.js + 2 modules
var Group = __webpack_require__(6137);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(5117);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./public/icons/burger_category.png
/* harmony default export */ var burger_category = ({"src":"/_next/static/media/burger_category.1c08337e.png","height":117,"width":117,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAKlBMVEWo7+ut8++n7uqn7utzu7VwuLOn7uqP3thLk42i6uZ7z8lBioNVnJd4wLvrWBBQAAAAB3RSTlP+/oej/v1r1o1wJgAAAAlwSFlzAAAhOAAAITgBRZYxYAAAADRJREFUCJlVi7kRACAMw2y+OAT2X5dLOlT4VFjoKFqOuwOgbSkGU450f1HEZF7NzKsjifUAKaYBPOKRH34AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./common/components/DanhMuc.js







// import imgBurger2 from "public/icons/burder_filter.png";


function DanhMuc(param) {
    var list = param.list, selected = param.selected, setSelected = param.setSelected, _title = param.title, title = _title === void 0 ? "Danh mục" : _title, _icon = param.icon, icon = _icon === void 0 ? burger_category : _icon, _isHDSD = param.isHDSD, isHDSD = _isHDSD === void 0 ? false : _isHDSD;
    var locale = (0,router.useRouter)().locale;
    if (title == "Danh mục" && locale == "en") {
        title = "Menu";
    }
    var handleTracking = function(link) {
        switch(link){
            case "hướng dẫn đăng k\xfd":
                return (0,tracking/* addtrackingEvent */.sm)({
                    vi_tri: tracking/* TRACKING_VI_TRI.HDSD */.QK.HDSD,
                    field_id: tracking/* TRACKING_NAMES.HDSD_Danhmuc_HDDK */.BK.HDSD_Danhmuc_HDDK
                });
            case "hướng dẫn nạp r\xfat tiền":
                return (0,tracking/* addtrackingEvent */.sm)({
                    vi_tri: tracking/* TRACKING_VI_TRI.HDSD */.QK.HDSD,
                    field_id: tracking/* TRACKING_NAMES.HDSD_Danhmuc_HDNRT */.BK.HDSD_Danhmuc_HDNRT
                });
            case "hướng dẫn đầu tư":
                return (0,tracking/* addtrackingEvent */.sm)({
                    vi_tri: tracking/* TRACKING_VI_TRI.HDSD */.QK.HDSD,
                    field_id: tracking/* TRACKING_NAMES.HDSD_Danhmuc_HDĐT */.BK["HDSD_Danhmuc_HDĐT"]
                });
            case "hướng dẫn giao dịch s\xe0n thứ cấp":
                return (0,tracking/* addtrackingEvent */.sm)({
                    vi_tri: tracking/* TRACKING_VI_TRI.HDSD */.QK.HDSD,
                    field_id: tracking/* TRACKING_NAMES.HDSD_Danhmuc_HDGDSTC */.BK.HDSD_Danhmuc_HDGDSTC
                });
            case "hỏi đ\xe1p thường gặp":
                return (0,tracking/* addtrackingEvent */.sm)({
                    vi_tri: tracking/* TRACKING_VI_TRI.HDSD */.QK.HDSD,
                    field_id: tracking/* TRACKING_NAMES.HDSD_Danhmuc_Hoidap */.BK.HDSD_Danhmuc_Hoidap
                });
            default:
                return;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        p: 16,
        sx: function(theme) {
            return {
                background: theme.colors.neutral[9],
                border: "1px solid ".concat(theme.colors.accent[2]),
                borderRadius: "16px"
            };
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                align: "center",
                mb: 17,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        sx: {
                            width: 39,
                            height: 39,
                            position: "relative"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: icon,
                            alt: "burger",
                            layout: "fill"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            size: "md",
                            weight: 500,
                            children: title
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                align: "center",
                noWrap: false,
                spacing: 6,
                children: list === null || list === void 0 ? void 0 : list.map(function(item, k) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsTag/* default */.Z, {
                        active: item === selected,
                        onClick: function() {
                            setSelected(item);
                            isHDSD && handleTracking(item);
                        },
                        children: (0,uppercaseFirstLetter/* uppercaseFirstLetter */.y)(item)
                    }, k);
                })
            })
        ]
    });
};


/***/ }),

/***/ 1623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6646);
/* harmony import */ var _utils_lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9926);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);






function DefaultSEO(param) {
    var seo = param.seo;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().locale;
    if (!seo || (0,_utils_lodash__WEBPACK_IMPORTED_MODULE_4__/* .isEmpty */ .xb)(seo)) return null;
    var images = [];
    if (seo.picture1) {
        images.push({
            url: (0,_utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                src: seo.picture1,
                size: "xl"
            }),
            width: 1200,
            height: 630,
            alt: "Đầu tư c\xf9ng ZenOne",
            type: "image/*"
        });
    }
    if (seo.picture2) {
        images.push({
            url: (0,_utils_appendImageUrlFromAPI__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                src: seo.picture2,
                size: "xl"
            }),
            width: 1200,
            height: 1200,
            alt: "ZenOne logo",
            type: "image/*"
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
        title: seo === null || seo === void 0 ? void 0 : seo.title,
        description: seo === null || seo === void 0 ? void 0 : seo.description,
        openGraph: {
            url: (seo === null || seo === void 0 ? void 0 : seo.url) ? "".concat("https://zenone.com.vn").concat(seo.url) : "https://zenone.com.vn",
            // url: "https://zenone.com.vn",
            title: seo.title,
            description: seo.description,
            images: images,
            locale: locale,
            type: seo.type || "website",
            siteName: "ZenOne",
            article: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (seo === null || seo === void 0 ? void 0 : seo.article) || {})
        },
        twitter: {
            cardType: "summary_large_image"
        }
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (DefaultSEO);


/***/ }),

/***/ 2231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ ChinhSach; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _apis_queryFunctions_pageInfo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1223);
/* harmony import */ var _common_components_Breadcrumbs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(753);
/* harmony import */ var _common_components_DanhMuc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3503);
/* harmony import */ var _common_components_DefaultSEO__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1623);
/* harmony import */ var _common_MainLayout_Container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7945);
/* harmony import */ var _utils_sanitizeDOMData__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2559);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9236);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7294);












var BrCrumb = {
    vi: [
        {
            href: "/",
            title: "Trang chủ"
        },
        {
            href: "/chinh-sach-dau-tu-hop-tac",
            title: "Ch\xednh s\xe1ch đầu tư/hợp t\xe1c"
        }, 
    ],
    en: [
        {
            href: "/",
            title: "Home"
        },
        {
            href: "/chinh-sach-dau-tu-hop-tac",
            title: "Investment/cooperation policy"
        }, 
    ]
};
var __N_SSG = true;
function ChinhSach() {
    var ref;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_8__.useState(null), 2), list = ref1[0], setList = ref1[1];
    var ref2 = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)(), locale = ref2.locale, asPath = ref2.asPath;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_8__.useState("ch\xednh s\xe1ch đầu tư bất động sản"), 2), selected = ref3[0], setSelected = ref3[1];
    var data = (0,_apis_queryFunctions_pageInfo__WEBPACK_IMPORTED_MODULE_1__/* .useFetchPageInfo */ .u$)("web-chinh-sach", {
        condition: {
            ngon_ngu: locale
        }
    }).data;
    // console.log(data);
    react__WEBPACK_IMPORTED_MODULE_8__.useEffect(function() {
        var ref;
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        router.query.keyword && data && ((ref = data.add_on_4) === null || ref === void 0 ? void 0 : ref.filter(function(el) {
            return el.shared;
        }).sort(function(a, b) {
            return (a === null || a === void 0 ? void 0 : a.stt) - (b === null || b === void 0 ? void 0 : b.stt);
        }).map(function(item) {
            if (item.label == router.query.keyword) {
                setSelected(item.id);
            }
        }));
    }, [
        router.query,
        data
    ]);
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_8__.useState(null), 2), option = ref4[0], setOption = ref4[1];
    react__WEBPACK_IMPORTED_MODULE_8__.useEffect(function() {
        var ref;
        var arr = [];
        data && ((ref = data.add_on_4) === null || ref === void 0 ? void 0 : ref.filter(function(el) {
            return el.shared;
        }).sort(function(a, b) {
            return (a === null || a === void 0 ? void 0 : a.stt) - (b === null || b === void 0 ? void 0 : b.stt);
        }).map(function(item) {
            arr.push(item.id);
        }));
        setOption(arr);
    }, [
        data
    ]);
    react__WEBPACK_IMPORTED_MODULE_8__.useEffect(function() {
        var ref;
        data && ((ref = data.add_on_4) === null || ref === void 0 ? void 0 : ref.filter(function(el) {
            return el.shared;
        }).sort(function(a, b) {
            return (a === null || a === void 0 ? void 0 : a.stt) - (b === null || b === void 0 ? void 0 : b.stt);
        }).map(function(item) {
            if (item.id == selected.toLowerCase()) {
                setList(item);
            }
        }));
    }, [
        data,
        selected
    ]);
    var seo = {
        title: data === null || data === void 0 ? void 0 : data.seo_title,
        description: data === null || data === void 0 ? void 0 : data.seo_description,
        picture1: data === null || data === void 0 ? void 0 : data.seo_image_1,
        picture2: data === null || data === void 0 ? void 0 : data.seo_image_2,
        url: asPath
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_common_MainLayout_Container__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_components_DefaultSEO__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                seo: seo
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_components_Breadcrumbs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                items: BrCrumb[locale],
                isLoading: false
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Grid */ .r, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Grid.Col */ .r.Col, {
                        md: 3
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Grid.Col */ .r.Col, {
                        md: 9,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_11__/* .Title */ .D, {
                            order: 1,
                            align: "center",
                            sx: function(theme) {
                                return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                                    fontSize: 36,
                                    // marginBottom: 40,
                                    fontWeight: "700",
                                    margin: "30px 0",
                                    "&:first-letter": {
                                        textTransform: "capitalize"
                                    }
                                }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
                                    textAlign: "center",
                                    fontSize: 24,
                                    marginBottom: 16
                                });
                            },
                            children: [
                                selected,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    style: {
                                        color: "#3CAEA4"
                                    },
                                    children: " ZenOne"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Grid */ .r, {
                sx: function(theme) {
                    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
                        paddingBottom: 55
                    }, "@media (max-width: ".concat(theme.breakpoints.md, "px)"), {
                        paddingBottom: 30
                    });
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Grid.Col */ .r.Col, {
                        md: 3,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_common_components_DanhMuc__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            list: option,
                            selected: selected,
                            setSelected: setSelected
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_10__/* .Grid.Col */ .r.Col, {
                        md: 9,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "webview",
                            children: list && (0,_utils_sanitizeDOMData__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((ref = list === null || list === void 0 ? void 0 : list.text_field[0]) === null || ref === void 0 ? void 0 : ref.content_editor)
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 5704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NewsTag; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mantine_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7414);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);






function NewsTag(_param) {
    var _active = _param.active, active = _active === void 0 ? false : _active, children = _param.children, etc = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "active",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mantine_core__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        sx: {
            background: active ? "#001529" : "#FFFFFF",
            color: active ? "#A8EFEB" : "#414141",
            border: active ? "1px solid #001529" : "1px solid #ADB4BB",
            fontSize: 16,
            fontWeight: 500,
            padding: "8px 9px",
            borderRadius: 7,
            cursor: "pointer"
        }
    }, etc), {
        children: children
    }));
};


/***/ }),

/***/ 4571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ uppercaseFirstLetter; }
/* harmony export */ });
function uppercaseFirstLetter(string) {
    if (!string || typeof string !== "string") return "";
    //split the above string into an array of strings
    //whenever a blank space is encountered
    var arr = string.split(" ");
    //loop through each element of the array and capitalize the first letter.
    for(var i = 0; i < arr.length; i++){
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    //Join all the elements of the array back into a string
    //using a blankspace as a separator
    var str2 = arr.join(" ");
    //Outptut: I Have Learned Something New Today
    return str2;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(3992); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);